import dayjs from 'dayjs';
import numeral from './numeral';

export const isServer = typeof window === 'undefined';

export const randomStr = (length, possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => {
  let text = '';
  for (let i = 0; i < length; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

export const emailSecret = (email) => {
  const arr = (email || '').split('.');
  const startStr = (email || '').substring(0, 3);
  const endStr = arr.pop();
  return `${startStr}************${endStr}`;
};

export const formatPhoneNumber = (num = '') => {
  if (!num) {
    return '';
  }

  let number = num.replace(/-/g, '').trim();
  number = number.replace(/\+/g, '').trim();

  const mobileSplit = (str) => `${str.substr(0, 1)}-${str.substr(1, 4)}-${str.substr(5)}`;
  const phoneBkkSplit = (str) => `${str.substr(0, 1)}-${str.substr(1, 4)}-${str.substr(5)}`;
  const phoneSplit = (str) => `${str.substr(0, 1)}-${str.substr(1, 4)}-${str.substr(5)}`;

  let phoneNumber = number;
  if (number.substr(0, 1) === '0' && number.length === 10) {
    phoneNumber = `0${mobileSplit(number.substr(1))}`;
  } else if (number.substr(0, 2) === '66' && number.length === 11) {
    phoneNumber = `0${mobileSplit(number.substr(2))}`;
  } else if (number.substr(0, 3) === '662' && number.length === 10) {
    phoneNumber = `${phoneBkkSplit(`0${number.substr(2)}`)}`;
  } else if (number.substr(0, 2) === '66' && number.length === 10) {
    phoneNumber = `${phoneSplit(`0${number.substr(2)}`)}`;
  } else if (number.substr(0, 2) === '02' && number.length === 9) {
    phoneNumber = `${phoneBkkSplit(number)}`;
  } else if (number.substr(0, 1) === '0' && number.length === 9) {
    phoneNumber = `${phoneSplit(number)}`;
  }

  return phoneNumber;
};

export const formatDate = (date, format = 'YYYY-MM-DD') => {
  try {
    const d = date === undefined ? dayjs() : dayjs(date, format);
    if (date !== undefined && (!date || !d.isValid())) {
      return '';
    }
    return d.format('DD/MM/YYYY');
  } catch (err) {
    return '';
  }
};

export const formatDateTime = (datetime, format = 'YYYY-MM-DD HH:mm:ss') => {
  try {
    const d = datetime === undefined ? dayjs() : dayjs(datetime, format);
    if (datetime !== undefined && (!datetime || !d.isValid())) {
      return '';
    }
    return d.format('DD/MM/YYYY, HH:mm');
  } catch (err) {
    return '';
  }
};

// pageNumber = 0
export const paginate = (array, pageSize, pageNumber) => {
  if (pageSize === -1) {
    return array;
  }
  return (
    Array.isArray(array)
      ? array.slice((pageNumber) * pageSize, (pageNumber + 1) * pageSize)
      : []
  );
};

export const can = (permission, state) => {
  if (!permission || !state || !state.user || !state.user.permissions) {
    return false;
  }

  const { user } = state;
  const permissions = user.permissions.map((p) => p.name);
  const result = permissions.some((p) => p === permission);
  return result;
};

export const isNumber = (n) => /^-?[\d.]+(?:e-?\d+)?$/.test(n);

export const isDecimal = (num) => num % 1 !== 0;

const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};
export const titleCase = (str) => str.split('_').map((s) => capitalize(s)).join('');

export const energyUnitDisplay = (number, suffixUnit = '') => {
  let newNumber = '';
  let unit = '';
  if (number < 1000) {
    newNumber = number;
    unit = 'kW';
  } if (number >= 1000 && number < 10000) {
    newNumber = number / 1000;
    unit = 'MW';
  } if (number >= 10000) {
    newNumber = number / 10000;
    unit = 'GW';
  }
  return {
    text: `${numeral(newNumber).format(isDecimal(newNumber) ? '0,0.00' : '0,0')} ${unit}${suffixUnit}`,
    numberText: numeral(newNumber).format(isDecimal(newNumber) ? '0,0.00' : '0,0'),
    number: newNumber,
    unit: `${unit}${suffixUnit}`,
  };
};

export const lowEnergyUnitDisplay = (numberInKW, suffixUnit = '') => {
  let newNumber = '';
  let unit = '';
  if (numberInKW < 1) {
    newNumber = numberInKW * 1000;
    unit = 'W';
  } else if (numberInKW < 1000) {
    newNumber = numberInKW;
    unit = 'kW';
  } else if (numberInKW >= 1000 && numberInKW < 10000) {
    newNumber = numberInKW / 1000;
    unit = 'MW';
  } else if (numberInKW >= 10000) {
    newNumber = numberInKW / 10000;
    unit = 'GW';
  }
  return {
    text: `${numeral(newNumber).format(isDecimal(newNumber) ? '0,0.00' : '0,0')} ${unit}${suffixUnit}`,
    numberText: numeral(newNumber).format(isDecimal(newNumber) ? '0,0.00' : '0,0'),
    number: newNumber,
    unit: `${unit}${suffixUnit}`,
  };
};

export const sleep = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export const fullAddressToAddress = (
  address, fullAddress, locale = 'th',
) => {
  if (!fullAddress) {
    return address;
  }
  const {
    provinceName, districtName, subDistrictName, postalCode,
    provinceNameEn, districtNameEn, subDistrictNameEn,
  } = fullAddress;

  const isBangkok = (provinceName || '').indexOf('กรุงเทพ') !== -1;

  let addressText = '';
  if (address) {
    addressText += address;
  }

  if (locale !== 'th') {
    return `${addressText}, ${subDistrictNameEn}, ${districtNameEn}, ${provinceNameEn}, ${postalCode}`;
  }

  if (subDistrictName) {
    let prefix = '';
    const hasPrefix = subDistrictName.indexOf('แขวง') !== -1 || subDistrictName.indexOf('ตำบล') !== -1;
    if (!hasPrefix) {
      prefix = isBangkok ? 'แขวง' : 'ตำบล';
    }
    addressText += ` ${prefix}${subDistrictName}`;
  }
  if (districtName) {
    let prefix = '';
    const hasPrefix = districtName.indexOf('เขต') !== -1 || districtName.indexOf('อำเภอ') !== -1;
    if (!hasPrefix) {
      prefix = isBangkok ? 'เขต' : 'อำเภอ';
    }
    addressText += ` ${prefix}${districtName}`;
  }
  if (provinceName) {
    let prefix = '';
    const hasPrefix = provinceName.indexOf('จังหวัด') !== -1;
    if (!hasPrefix) {
      prefix = isBangkok ? '' : 'จังหวัด';
    }
    addressText += ` ${prefix}${provinceName}`;
  }
  if (postalCode) {
    addressText += ` ${postalCode}`;
  }

  return addressText;
};

export const validateMobilePhoneNumber = (value) => {
  const patternWithZero = /^0[869]\d{8}$/;
  const patternWithNoZero = /^[869]\d{8}$/;
  const patternWithCountryCode = /^66[869]\d{8}$/;

  if (
    value.match(patternWithZero)
    || value.match(patternWithNoZero)
    || value.match(patternWithCountryCode)
  ) {
    return true;
  }
  return false;
};

export const validateEmail = (email) => {
  if (!email) {
    return false;
  }
  const pattern = /^[a-zA-Z0-9][a-zA-Z0-9_%+-.]+[@][a-zA-Z0-9-.]+[.][a-zA-Z0-9.]+$/;
  if (email.match(pattern)) {
    return true;
  }
  return false;
};

export const toFloat = (num, decimal = 2) => {
  let isNegative = false;
  let tmpNumber = num;
  if (typeof num === 'string') {
    tmpNumber = (num || '').split(',').join('');
  }
  if (tmpNumber < 0) {
    isNegative = true;
    tmpNumber *= -1;
  }
  const multiplicator = 10 ** decimal;
  tmpNumber = parseFloat((tmpNumber * multiplicator).toFixed(11));
  tmpNumber = (Math.round(tmpNumber) / multiplicator).toFixed(decimal);

  if (isNegative) {
    tmpNumber *= -1;
  }
  return parseFloat(parseFloat(tmpNumber).toFixed(decimal));
};

export const emptyVal = (val) => (val === '' ? null : val);

export default {};
